import React, { Component } from "react";

//component
import CariAppFormViewPg3 from "../presentational/CariAppFormViewPg3";
import { Growl } from 'primereact/growl';

//generic functions
import {
    isEmpty,
    cloneObject
} from "../../../../../functions/generic_functions";

//router
import {
    withRouter,
} from 'react-router-dom';

//static routes
import {
    cari_api_delete_file_url,
    cari_api_upload_file_url,
    cari_api_replace_upload_file_url,
    cari_api_load_form_page_3_url,
    cari_home_pg_url,
    cari_api_save_doc_comments_url
} from "../../../../../router/static_routes";

//redux
import { connect } from "react-redux";
import {
    setCariFormActiveApplicationData,
    openCariModal,
    resetCariActiveData
} from "../../../../../redux/actions/indexActions";
//redux mappers
const mapStateToProps = state => {
    return {
        activeApplicationData: state.cariReducer.activeApplicationData,
        activeVerifiedLoginUserData: state.cariReducer.activeVerifiedLoginUserData
    };
};
const mapDispatchToProps = dispatch => {

    return {
        setCariFormActiveApplicationData: (application_data) => {
            dispatch(setCariFormActiveApplicationData(application_data))
        },
        openCariModal: (modal_data) => {
            dispatch(openCariModal(modal_data))
        },
        resetCariActiveData: () => {
            dispatch(resetCariActiveData())
        },
    };
};

class CariAppFormContainerPg3 extends Component {

    state = {
        mounted: false,
        pageLoaded: false,
        submitted: false,

        maxFileSize: 20000000,
        page_num: 3,

        staticUiData: {
            documentList: [],
        },
    }

    constructor(props) {
        super(props);

        //refs
        this.toastRef = React.createRef();

        //action handlers
        this.handleOnChangeSetParentState = this.handleOnChangeSetParentState.bind(this);
        this.handleOnFileUpload = this.handleOnFileUpload.bind(this);
        this.handleOnFileDelete = this.handleOnFileDelete.bind(this);
        this.handleOnFileReplaceUpload = this.handleOnFileReplaceUpload.bind(this);
        this.handleOnSaveAddCommentsToDocsUploadedModal = this.handleOnSaveAddCommentsToDocsUploadedModal.bind(this);

        //reload page
        this.reloadPageData = this.reloadPageData.bind(this);

        //load page data
        this.load_page_data_from_api = this.load_page_data_from_api.bind(this);
    }



    /*
        post parameters {
            application_id,
            email,
            token, //TODO remove after
        }
           
        //NOTE required is not required for consideration
        return data {
            status => true/false,
            message {
                staticUiData: {
                    application_status: "", //values can be: "initial", "completed", or null by default(meaning not created yet)
                    documentList: [
                        {
                            doc_type: "CV",
                            max_docs: 1,
                            min_docs: 1,
                            required: true,
                            files: [
                                // { fileName: "cv_file.pdf", fileSize: 100000, app_docs_id: 1 },
                            ],
                        },
                        {
                            doc_type: "Cover letter",
                            max_docs: 1,
                            min_docs: 1,
                            required: true,
                            files: [
                                { fileName: "cover_letter_file.pdf", fileSize: 100000, app_docs_id: 2 },
                            ],
                        },
                        {
                            doc_type: "Teaching Dossier",
                            max_docs: 1,
                            min_docs: 1,
                            required: false,
                            files: [
                                { fileName: "teaching_dossier_file.pdf", fileSize: 2000000, app_docs_id: 3 },
                            ],
                        },
                        {
                            doc_type: "List of Courses taught",
                            max_docs: 1,
                            min_docs: 1,
                            required: false,
                            files: [
                                { fileName: "list of courses file.pdf", fileSize: 100000, app_docs_id: 4 },
                            ],
                        },
                        {

                            doc_type: "Teaching evaluation",
                            max_docs: 1,
                            min_docs: 1,
                            required: true,
                            files: [
                                // { fileName: "teaching evaluation file.docx", fileSize: 9000000, app_docs_id: 5 },
                            ],
                        },
                        {
                            doc_type: "Three most significant papers",
                            max_docs: 6,
                            min_docs: 2,
                            required: true,
                            files: [
                                { fileName: "publication_file_1.doc", fileSize: 4000000, app_docs_id: 6 },
                                { fileName: "publication_file_2.docx", fileSize: 5000000, app_docs_id: 7 },
                                { fileName: "publication_file_3.pdf", fileSize: 6000000, app_docs_id: 8 },
                                { fileName: "publication_file_4.pdf", fileSize: 7000000, app_docs_id: 9 },
                                { fileName: "publication_file_5.pdf", fileSize: 8000000, app_docs_id: 10 }
                            ],
                        },
                        {
                            doc_type: "Other Optional Attachments",
                            max_docs: 1,
                            min_docs: 1,
                            required: false,
                            min_required: false,
                            files: [
                                { fileName: "randomFIle.doc", fileSize: 999999, app_docs_id: 11 },
                            ],
                        },
                    ],
                }
            }
        } 
    */
    load_page_data_from_api() {

        //add email and application_id, token to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);

        //fetch page data from parameters
        fetch(cari_api_load_form_page_3_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        })
        .then((response) => {
            
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status 
                && !isEmpty(JSON.parse(json.message))
                && !isEmpty(JSON.parse(json.message).staticUiData)
            ) {
                var json_data = JSON.parse(json.message);
                var fetchedPageData = json_data;

                //set the submitted value as true/false if the string value of application status is complete data from fetched page data json
                var fetchedSubmittedVal = false
                var fetchedApplicationStatus = null;
                if (!isEmpty(fetchedPageData.application_status)) {
                    fetchedApplicationStatus = fetchedPageData.application_status;
                    fetchedSubmittedVal = (fetchedPageData.application_status.toLowerCase() === "complete");
                }

                //init copy of staticUiData of local state
                var copyStaticUiData = cloneObject(this.state.staticUiData);
                var fetchedStaticUiData = fetchedPageData.staticUiData;

                //set static Ui Data to local state
                for (let stateKey in copyStaticUiData) {
                    let currFetchedVal = fetchedStaticUiData[stateKey];
                    if (!isEmpty(currFetchedVal)) {

                        //if the key is documentList, loop through and build a "nameKey" mapping to its document type_index
                        /*
                            doc_type [
                                {
                                    files [
                                        {
                                            //add a new name key here ie: doc_Type_0
                                        }
                                       
                                    ]
                                    //add new field here
                                    enableDeleteMode: true/false depends on if current number of files is above min
                                }
                            ]
                        */

                        if(stateKey === "documentList") {
                            var docTypeList = currFetchedVal;

                            //loop through document type array
                            for (var docTypeKey in currFetchedVal) {
                                var docIndex = 0;

                                //get doc files list for this doc type
                                var docType = currFetchedVal[docTypeKey]['doc_type'];
                                var docList = currFetchedVal[docTypeKey]['files'];
                                var curr_min_docs = currFetchedVal[docTypeKey]['min_docs'];

                                //loop through the file list
                                for (var docKey in docList) {
                                    docTypeList[docTypeKey]['files'][docKey]["nameKey"] = docType + "_" + docIndex; 
                                    docIndex++;
                                }

                                //set delete mode if length of doc list is above min
                                var enableDeleteMode = false;
                                if (docList.length > curr_min_docs) {
                                    enableDeleteMode = true;
                                }
                                docTypeList[docTypeKey]['enableDeleteMode'] = enableDeleteMode;
                            }
                            copyStaticUiData[stateKey] = docTypeList;

                        }
                        else {
                            copyStaticUiData[stateKey] = currFetchedVal;
                        }
                    }
                }

                //set page loaded to true
                this.setState({
                    pageLoaded: true,
                    staticUiData: copyStaticUiData,
                    submitted: fetchedSubmittedVal,
                }, () => {
                    //save application status to store
                    var updatedApplicationData = this.props.activeApplicationData;
                    updatedApplicationData.application_status = fetchedApplicationStatus;
                    this.props.setCariFormActiveApplicationData(updatedApplicationData);
                });
            }
            //if api returns no data, popup modal 
            else {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Failed to retrieve data.",
                    callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
                });
            }
        })
        //if api is not found
        .catch((error) => {
            console.log(error);
            this.props.openCariModal({
                modalId: "errorModal",
                title: "Something went wrong.",
                callBackFuncOnOk: () => { this.props.history.push(cari_home_pg_url); }
            });
        });
    }

    componentDidMount() {
        this.setState({
            mounted: true
        }, () => {
            this.load_page_data_from_api();
        })
    }

    componentWillUnmount() {
        this.setState({
            mounted: false
        });
    }


    reloadPageData(fetchedPageData, callBackFunc) {
        var emptyStaticUiData = {
            documentList: [],
        }

        //reset the document list, on finish, set data
        this.setState({
            staticUiData: emptyStaticUiData
        }, () => {
            //set the submitted value as true/false if the string value of application status is complete data from fetched page data json
            var fetchedSubmittedVal = false
            var fetchedApplicationStatus = null;
            if (!isEmpty(fetchedPageData.application_status)) {
                fetchedApplicationStatus = fetchedPageData.application_status;
                fetchedSubmittedVal = (fetchedPageData.application_status.toLowerCase() === "complete");
            }

            //init copy of staticUiData of local state
            var copyStaticUiData = cloneObject(this.state.staticUiData);
            var fetchedStaticUiData = fetchedPageData.staticUiData;

            //set static Ui Data to local state
            for (let stateKey in copyStaticUiData) {
                let currFetchedVal = fetchedStaticUiData[stateKey];
                if (!isEmpty(currFetchedVal)) {

                    //if the key is documentList, loop through and build a "nameKey" mapping to its document type_index
                    /*
                        doc_type [
                            {
                                files [
                                    {
                                        //add a new name key here ie: doc_Type_0
                                    }
                                   
                                ]
                                //add new field here
                                enableDeleteMode: true/false depends on if current number of files is above min
                            }
                        ]
                    */

                    if (stateKey === "documentList") {
                        var docTypeList = currFetchedVal;

                        //loop through document type array
                        for (var docTypeKey in currFetchedVal) {
                            var docIndex = 0;

                            //get doc files list for this doc type
                            var docType = currFetchedVal[docTypeKey]['doc_type'];
                            var docList = currFetchedVal[docTypeKey]['files'];
                            var curr_min_docs = currFetchedVal[docTypeKey]['min_docs'];

                            //loop through the file list
                            for (var docKey in docList) {
                                docTypeList[docTypeKey]['files'][docKey]["nameKey"] = docType + "_" + docIndex;
                                docIndex++;
                            }

                            //set delete mode if length of doc list is above min
                            var enableDeleteMode = false;
                            if (docList.length > curr_min_docs) {
                                enableDeleteMode = true;
                            }
                            docTypeList[docTypeKey]['enableDeleteMode'] = enableDeleteMode;
                        }
                        copyStaticUiData[stateKey] = docTypeList;

                    }
                    else {
                        copyStaticUiData[stateKey] = currFetchedVal;
                    }
                }
            }

            //set page loaded to true
            this.setState({
                pageLoaded: true,
                staticUiData: copyStaticUiData,
                submitted: fetchedSubmittedVal,
            }, () => {

                //save application status to store
                var updatedApplicationData = this.props.activeApplicationData;
                updatedApplicationData.application_status = fetchedApplicationStatus;
                this.props.setCariFormActiveApplicationData(updatedApplicationData);

                //call back function if not null
                if (!isEmpty(callBackFunc)) {
                    callBackFunc();
                }
            });
        });
    }


    /*
        on file upload, call api to upload and calls a call back function that for true or false
    */
   /*
        post parameters {
            application_id,
            email,
            token, //TODO remove after,
            supporting_doc,
            doc_type
        }

        return data {
            status => true / false,
            message {
                app_docs_id: "",
                staticUiData,
                application_status
            }
        }
    */
    handleOnFileUpload(fileObj, callBackFunc) {
        //add email and application_id, token and file to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        //get file data
        var file = fileObj.file;
        var doc_type = fileObj.doc_type;

        var form_data = new FormData();
        form_data.append("supporting_doc", file);
        form_data.append("doc_type", doc_type);
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);

        //fetch page data from parameters
        fetch(cari_api_upload_file_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    // this.props.openCariModal({
                    //     modalId: "errorModal",
                    //     title: "User Session is invalid or has expired, please login again.",
                    //     callBackFuncOnOk: () => {
                    //         this.props.resetCariActiveData();
                    //     }
                    // });
                }
            }
        }).then(json => {
                //successfully processed request
                if (!isEmpty(json.status)
                    && json.status
                    && !isEmpty(JSON.parse(json.message))
                ) {
                    var json_data = JSON.parse(json.message);
                    var app_docs_id = null;

                    //check if app docs id is not null
                    if (!isEmpty(json_data.app_docs_id)) {
                        app_docs_id = json_data.app_docs_id;

                        callBackFunc(null, null);


                        //call back to hide uploading icon
                        // callBackFunc(null, () => {
                            //call back to reload page and display toast

                        this.reloadPageData(json_data, () => {
                            this.toastRef.current.show({ life: 6000, severity: 'success', summary: 'Successfully uploaded the file', detail: "" });
                        });
                        // });

                        // //call back to reload page and display toast
                        // this.reloadPageData(json_data, () => {
                        //     this.toastRef.current.show({ severity: 'success', summary: 'Successfully uploaded the file', detail: "" });
                        // });
                    }
                    else {
                        callBackFunc(null, () => {
                            //display toast
                            this.toastRef.current.show({ life: 6000, severity: 'success', danger: 'Failed to upload the file', detail: "" });
                        });
                    }
                }
                else {
                    callBackFunc(null, () => {
                        //display toast
                        this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to upload the file', detail: "" });
                    });
                }
            })
            //if api is not found
            .catch((error) => {
                console.log(error);
                //display toast
                this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to upload the file', detail: "" });
                callBackFunc(null, () => {
                  
                });
            });
    }


    /*
        on file replace upload, call api to upload and calls a call back function that for true or false
    */
    /*
         post parameters {
             application_id,
             email,
             token, //TODO remove after,
             supporting_doc,
             doc_type,
             replace_app_docs_id
         }
 
         return data {
             status => true / false,
             message { 
                 app_docs_id: "",
                 staticUiData,
                 application_status
             }
         }
     */
    handleOnFileReplaceUpload(fileObj, callBackFunc) {
        //add email and application_id, token and file to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;
        var replace_app_docs_id = fileObj.replace_app_docs_id;

        //get file data
        var file = fileObj.file;
        var doc_type = fileObj.doc_type;

        var form_data = new FormData();
        form_data.append("supporting_doc", file);
        form_data.append("doc_type", doc_type);
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);
        form_data.append("replace_app_docs_id", replace_app_docs_id);

        //fetch page data from parameters
        fetch(cari_api_replace_upload_file_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json.status)
                && json.status
                && !isEmpty(JSON.parse(json.message))
            ) {
                var json_data = JSON.parse(json.message);
                var app_docs_id = null;

                //check if app docs id is not null
                if (!isEmpty(json_data.app_docs_id)) {
                    app_docs_id = json_data.app_docs_id;

                    //close loading icon
                    callBackFunc(null, null);

                    //reload page
                    this.reloadPageData(json_data, () => {
                        this.toastRef.current.show({ life: 6000, severity: 'success', summary: 'Successfully replaced the file', detail: "" });
                    });
                }
                else {
                    callBackFunc(null, () => {
                        //display toast
                        this.toastRef.current.show({ life: 6000,severity: 'success', danger: 'Failed to replace the file', detail: "" });
                    });
                }
            }
            else {
                callBackFunc(null, () => {
                    //display toast
                    this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to replace the file', detail: "" });
                });
            }
        })
            //if api is not found
            .catch((error) => {
                console.log(error);
                //display toast
                this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to replace the file', detail: "" });
                callBackFunc(null, () => {

                });
            });
    }

    /*
        handles file deletion to call api 
        returns true/false for success
    */
      /*
        post parameters {
            application_id,
            email,
            token, //TODO remove after
        }

        return data {
            status => true / false,
            message {
                fileDeleted: true/false
            }
        }
    */
    handleOnFileDelete(app_docs_id, callBackFunc) {
        //add email and application_id, token and file to post data
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        //get file data
        var form_data = new FormData();
        form_data.append("app_docs_id", app_docs_id);
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("token", currentToken);

        //fetch page data from parameters
        fetch(cari_api_delete_file_url, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            //only continue fetch if mounted
            if (this.state.mounted) {
                var responseHttpCode = response.status;
                //good request
                if (responseHttpCode === 200) {
                    return response.json();
                }
                //404 api not found, allows user to retry
                else if (responseHttpCode === 404) {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "Bad Request, please try again.",
                    });
                }
                //invalid data and not authorized, reset cari data
                else {
                    this.props.openCariModal({
                        modalId: "errorModal",
                        title: "User Session is invalid or has expired, please login again.",
                        callBackFuncOnOk: () => {
                            this.props.resetCariActiveData();
                        }
                    });
                }
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json.status)
                && json.status
                && !isEmpty(JSON.parse(json.message))
                && JSON.parse(json.message).fileDeleted
            ) {
                var json_data = JSON.parse(json.message);

                //call back to reload page and display toast
                this.reloadPageData(json_data, () => {
                    this.toastRef.current.show({ life: 6000, severity: 'success', summary: 'Successfully deleted the file', detail: "" });
                });
            
            }
            //if api returns no data, display toast
            else {
                this.toastRef.current.show({ life: 6000, severity: 'danger', summary: 'Failed to delete the file', detail: "" });
            }
        })
        //if api is not found
        .catch((error) => {
            console.log(error);
            //display toast
            this.toastRef.current.show({ life: 6000, severity: 'error', summary: 'Failed to delete the file', detail: "" });
        });
    }

    handleOnSaveAddCommentsToDocsUploadedModal(app_docs_id, comments, callBackFunc) {
        var saveDocCommentsUrl = cari_api_save_doc_comments_url;

        var note = comments;
        var currentEmail = this.props.activeVerifiedLoginUserData.email;
        var currentToken = this.props.activeVerifiedLoginUserData.token;
        var currentApplicationId = this.props.activeApplicationData.application_id;

        //set comments and app_doc id
        var form_data = new FormData();
        form_data.append("email", currentEmail);
        form_data.append("application_id", currentApplicationId);
        form_data.append("app_docs_id", app_docs_id);
        form_data.append("note", note); 
        form_data.append("token", currentToken);

        fetch(saveDocCommentsUrl, {
            method: 'POST',
            body: form_data,
            headers: {
                'Accept': 'application/json',
            }
        }).then((response) => {
            var responseHttpCode = response.status;
            //good request
            if (responseHttpCode === 200) {
                return response.json();
            }
            //404 api not found, allows user to retry
            else if (responseHttpCode === 404) {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "Bad Request, please try again.",
                });
            }
            //invalid data and not authorized, reset cari data
            else {
                this.props.openCariModal({
                    modalId: "errorModal",
                    title: "User Session is invalid or has expired, please login again.",
                    callBackFuncOnOk: () => {
                        this.props.resetCariActiveData();
                    }
                });
            }
        }).then(json => {
            //successfully processed request
            if (!isEmpty(json)
                && !isEmpty(json.status)
                && json.status 
                && !isEmpty(JSON.parse(json.message))
                && JSON.parse(json.message).commentsUpdated
            ) {
                var json_data = JSON.parse(json.message);
                
                //call back to reload page and display toast
                this.reloadPageData(json_data, () => {
                    this.toastRef.current.show({ life: 6000, severity: 'success', summary: 'Comment Updated', detail: "" });
                });
            
            }
            //if api returns no data
            else {
                this.toastRef.current.show({ life: 6000, severity: 'danger', summary: 'Failed to update comment', detail: "" });
            }
        })
        //if api is not found
        .catch((error) => {
            this.toastRef.current.show({ life: 6000, severity: 'danger', summary: 'Failed to update comment', detail: "" });
        });

    }



    //handles on change events for setting states for form input for post data
    handleOnChangeSetParentState(value, groupName) {

    }

    render() {
        return (
            <div>
                <Growl
                    ref={this.toastRef}
                    baseZIndex={9000}
                    position={"topright"}
                />
                <CariAppFormViewPg3
                    pageLoaded={this.state.pageLoaded}
                    staticUiData={this.state.staticUiData}
                    maxFileSize={this.state.maxFileSize}
                    onChangeSetParentState={this.handleOnChangeSetParentState}
                    onFileUpload={this.handleOnFileUpload}
                    onFileDelete={this.handleOnFileDelete}
                    onFileReplaceUpload={this.handleOnFileReplaceUpload}
                    onSaveAddCommentsToDocsUploadedModal={this.handleOnSaveAddCommentsToDocsUploadedModal}
                />
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CariAppFormContainerPg3));